import { useState } from 'react';
import { motion } from 'motion/react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { WaitlistModal } from '@/components/landing/WaitlistModal';
import { LANDING_COLORS } from '@/constants/landing-colors';

interface DirectoryPromoBannerB2CProps {
  onTrack?: (key: string) => void;
}

export function DirectoryPromoBannerB2C({ onTrack }: DirectoryPromoBannerB2CProps) {
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  // Jams está "PRÓXIMAMENTE": captamos al músico en la waitlist (HubSpot B2C) en vez de
  // llevarlo a /jams. Cuando Jams lance, cambiar por navegación a AUTH_LINKS.jams.signup.
  const handleClick = () => {
    onTrack?.('promo_jams_click');
    setWaitlistOpen(true);
  };

  return (
    <>
    <WaitlistModal open={waitlistOpen} onOpenChange={setWaitlistOpen} colors={LANDING_COLORS.jams} />
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="relative h-full overflow-hidden rounded-2xl shadow-xl"
    >
      {/* Imagen de fondo */}
      <div
        className="absolute inset-0 bg-cover"
        style={{
          backgroundImage:
            'url(https://images.unsplash.com/photo-1770954179424-ce8a9d809d94?w=800&auto=format&fit=crop&q=80)',
          backgroundPosition: 'center 30%',
        }}
      />

      {/* Overlay gradiente */}
      <div className="absolute inset-0 bg-gradient-to-t from-neutral-900/90 via-neutral-800/50 to-transparent" />

      {/* Contenido — h-full para igualar la altura de las cards de su fila en el grid */}
      <div className="relative flex h-full min-h-[240px] flex-col justify-end p-5">
        {/* Badge pequeño */}
        <div className="mb-2 inline-flex items-center gap-2 self-start rounded-full bg-white/10 px-3 py-1 backdrop-blur-sm">
          <Sparkles className="h-3.5 w-3.5 text-white/80" />
          <span className="text-xs font-bold uppercase tracking-wider text-white/80">
            PRÓXIMAMENTE
          </span>
        </div>

        {/* Headline */}
        <h4 className="mb-1 text-lg font-black uppercase tracking-tight text-white">
          ENCUENTRA MÚSICOS<br />CERCA DE TI
        </h4>
        <p className="mb-4 text-xs font-bold uppercase tracking-wide text-white/60">
          JAM SESSIONS Y PROYECTOS
        </p>

        {/* CTA */}
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={handleClick}
          className="flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-white shadow-lg transition-all hover:opacity-90 hover:shadow-xl"
          style={{ backgroundColor: '#4F46E5' }}
        >
          EXPLORAR JAMS
          <ArrowRight className="h-4 w-4" />
        </motion.button>
      </div>
    </motion.div>
    </>
  );
}
